import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import { Form, actions } from 'react-redux-form/immutable'
import { Fieldset, Row, Field } from 'react-gridforms'

import Input from 'components/Input'

class FormChangeSemester extends Component {

  componentWillMount() {
    const { value, dispatch } = this.props
    // populate form
    dispatch(actions.load('changeSemState', fromJS({
      sy: value.get('sy'),
      sem: value.get('sem'),
    })))
  }

  _onChangeSy = (e) => {
    const value = e.target.value
    const intValue = Number(value)
    // autocomplete school year
    if (value.length === 4 && intValue && e.keyCode !== 8) { // 8: backspace
      this.props.dispatch(actions.change('changeSemState.sy', `${value}-${intValue + 1}`))
    }
  }

  render() {
    const { onSubmit } = this.props

    return (
      <Form
        model="changeSemState"
        className="grid-form"
        onSubmit={onSubmit}
      >
        <Fieldset legend="Change Semester">
          <Row>
            <Field span={3}>
              <Input
                model=".sy"
                label="School Year"
                maxLength={9}
                onKeyUp={this._onChangeSy}
                required
                autoFocus
              />
            </Field>
            <Field span={1}>
              <Input
                model=".sem"
                label="Semester"
                maxLength={1}
                required
              />
            </Field>
          </Row>
        </Fieldset>
        <div className="modal-footer">
          <button type="submit" className="btn btn-primary">Change Semester</button>
        </div>
      </Form>
    )
  }
}

FormChangeSemester.propTypes = {
  value: PropTypes.object,
  dispatch: PropTypes.func,
  onSubmit: PropTypes.func,
}

export default connect()(FormChangeSemester)



// WEBPACK FOOTER //
// ./src/components/ChangeSemester/form-change-semester.js